import {Component, NgModule} from '@angular/core';

@Component({
  selector: 'sd-divider',
  standalone: true,
  template: '',
  host: {class: 'sd-divider my-2 block h-px w-full bg-[var(--m365-border-rest,#ececf0)]'},
})
export class SdDivider {}

@NgModule({
  imports: [SdDivider],
  exports: [SdDivider],
})
export class SdDividerModule {}
